// Smooth-scrolls CTAs opted into an in-page anchor (blocks/button_block.liquid).
// Delegated from the document so one module serves every button on the page.
document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const target = event.target;
  if (!(target instanceof Element)) return;

  const trigger = target.closest('a[data-anchor-scroll]');
  if (!trigger) return;

  const hash = trigger.getAttribute('href') || '';
  if (hash.charAt(0) !== '#' || hash.length < 2) return;

  const destination = document.getElementById(hash.slice(1));
  if (!destination) return;

  event.preventDefault();

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  destination.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

  // Match what the native jump gives: the hash in the URL and focus on the target.
  if (!destination.hasAttribute('tabindex')) destination.setAttribute('tabindex', '-1');
  destination.focus({ preventScroll: true });

  if (window.history && typeof window.history.pushState === 'function') {
    window.history.pushState(null, '', hash);
  }
});
